'use strict';

bbw.directive.bbwEmailNotExists = ['rpcClient', '$q', '$timeout', function(rpcClient, $q, $timeout) {

    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.bbwEmailNotExists = function(modelValue, viewValue) {
                return rpcClient.post('/check-email', {
                    email: viewValue
                }).execute()
                    .catch(function(e) {
                        if (e && e.error && e.error === 'validation_failed') {
                            $timeout(function() {
                                ngModel.$error.email = true;
                            });
                            return $q.reject();
                        }
                        return $q.when();
                    })
                    .then(function(response) {
                        if (angular.isDefined(response)) {
                            if (response.success && !response.exists) {
                                return true;
                            }
                            return $q.reject();
                        }
                    });
            };
        }
    }
}];
